import React, { useEffect, useState } from "react";
import { getLowStock } from "../../services/api/stocks/stockService";

const LowStock = () => {
  const [lowStock, setLowStock] = useState([]);
  const [filteredStock, setFilteredStock] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  useEffect(() => {
    fetchLowStock();
  }, []);

  const fetchLowStock = async () => {
    try {
      const res = await getLowStock();
      setLowStock(res.data.data);
      setFilteredStock(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const filtered = lowStock.filter((item) =>
      item.boq_item?.item_name
        ?.toLowerCase()
        .includes(search.toLowerCase())
    );

    setFilteredStock(filtered);
    setCurrentPage(1);
  }, [search, lowStock]);

  const totalPages = Math.ceil(filteredStock.length / itemsPerPage);

  const paginatedData = filteredStock.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const criticalCount = lowStock.filter(
    (item) => item.available_qty < 5
  ).length;

  return (
    <div className="p-4 md:p-6 space-y-6">

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">

        <div className="bg-white rounded-xl shadow-md p-4">
          <p className="text-sm text-gray-500">Low Stock Items</p>
          <h2 className="text-2xl font-bold text-yellow-600">
            {lowStock.length}
          </h2>
        </div>

        <div className="bg-white rounded-xl shadow-md p-4">
          <p className="text-sm text-gray-500">Critical Items</p>
          <h2 className="text-2xl font-bold text-red-600">
            {criticalCount}
          </h2>
        </div>

        <div className="bg-white rounded-xl shadow-md p-4">
          <p className="text-sm text-gray-500">Safe Items</p>
          <h2 className="text-2xl font-bold text-green-600">
            {lowStock.length - criticalCount}
          </h2>
        </div>

      </div>

      {/* Search */}
      <div className="bg-white rounded-xl shadow-md p-4">
        <input
          type="text"
          placeholder="Search low stock item..."
          className="border px-3 py-2 rounded-md w-full md:w-72"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Low Stock Table */}
      <div className="bg-white rounded-xl shadow-md p-4 md:p-6">

        <h2 className="text-xl font-semibold mb-4">
          Low Stock Items
        </h2>

        <div className="overflow-x-auto">
          <table className="min-w-full border rounded-lg">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 text-left">Item Name</th>
                <th className="p-3 text-left">Available Qty</th>
                <th className="p-3 text-left">Unit</th>
                <th className="p-3 text-left">Status</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={index} className="border-t">

                    <td className="p-3">
                      {item.boq_item?.item_name || "-"}
                    </td>

                    <td className="p-3">
                      {item.available_qty}
                    </td>

                    <td className="p-3">
                      {item.boq_item?.unit || "-"}
                    </td>

                    <td className="p-3">
                      {item.available_qty < 5 ? (
                        <span className="text-red-600 font-medium">
                          Critical
                        </span>
                      ) : (
                        <span className="text-yellow-600 font-medium">
                          Low
                        </span>
                      )}
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="p-4 text-center"
                  >
                    No low stock items
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-4 gap-2 flex-wrap">
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              className={`px-3 py-1 rounded ${
                currentPage === i + 1
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200"
              }`}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
        </div>

      </div>
    </div>
  );
};

export default LowStock;